var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("div", { staticClass: "model-content" }, [
            _c("div", { staticClass: "modal-card" }, [
              _c("header", { staticClass: "modal-card-head" }, [
                _c(
                  "p",
                  {
                    staticClass: "modal-card-title",
                    class: { "is-flex-items-center": _vm.showIcon },
                  },
                  [
                    _vm.showIcon
                      ? _c(
                          "span",
                          {
                            staticClass: "icon is-medium",
                            class: `has-text-${_vm.iconType}`,
                            staticStyle: { "margin-right": "0.5rem" },
                          },
                          [
                            _c("i", {
                              staticClass: "mdi mdi-36px",
                              class: `${_vm.iconName}`,
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._t("text-title"),
                  ],
                  2
                ),
              ]),
              _c("section", { staticClass: "modal-card-body" }, [
                _c("div", { staticClass: "field is-horizontal" }, [
                  _c("div", { staticClass: "field-label is-normal" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Item Type"),
                    ]),
                  ]),
                  _c("div", { staticClass: "field-body" }, [
                    _c("div", { staticClass: "field has-addons" }, [
                      _c("div", { staticClass: "control" }, [
                        _c("div", { staticClass: "select" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedItemType,
                                  expression: "selectedItemType",
                                },
                              ],
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.selectedItemType = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            _vm._l(
                              _vm.itemCategoryTypesFiltered,
                              function (itemCategoryType, prop) {
                                return _c(
                                  "option",
                                  { key: prop, domProps: { value: prop } },
                                  [_vm._v(_vm._s(itemCategoryType))]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                      ]),
                      _c("p", { staticClass: "control" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            attrs: { disabled: _vm.disableAdd },
                            on: { click: _vm.addPresentAs },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "msr msr-24px has-text-success" },
                              [_vm._v(" add_circle ")]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _c("hr", { staticClass: "has-background-grey-light" }),
                _vm.innerValue
                  ? _c(
                      "div",
                      { staticClass: "field" },
                      _vm._l(_vm.innerValue, function (split, index) {
                        return _c(
                          "div",
                          {
                            key: split.itemType,
                            staticClass: "field has-addons",
                          },
                          [
                            _c("p", { staticClass: "control" }, [
                              _c("a", { staticClass: "button is-static" }, [
                                _vm._v(" " + _vm._s(split.itemType) + " "),
                              ]),
                            ]),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "control is-flex is-align-items-center",
                              },
                              [
                                _c("vue-numeric", {
                                  directives: [
                                    {
                                      name: "focus-inserted",
                                      rawName: "v-focus-inserted",
                                    },
                                  ],
                                  staticClass: "input has-text-right no-radius",
                                  attrs: {
                                    min: 0,
                                    symbol: "%",
                                    "symbol-position": "suffix",
                                  },
                                  model: {
                                    value: split.percent,
                                    callback: function ($$v) {
                                      _vm.$set(split, "percent", $$v)
                                    },
                                    expression: "split.percent",
                                  },
                                }),
                                _c(
                                  "button",
                                  {
                                    staticClass: "button",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deletePresentAs(index)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "msr msr-24px has-text-danger",
                                      },
                                      [_vm._v("do_not_disturb_on")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
              _c("footer", { staticClass: "modal-card-foot" }, [
                _c(
                  "div",
                  { staticClass: "columns is-flex-grow-1", attrs: { S: "" } },
                  [
                    _c(
                      "div",
                      { staticClass: "column is-half is-flex-grow-1" },
                      [
                        !_vm.validPercentage
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "is-flex is-flex is-align-items-center has-text-danger",
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "mdi mdi-alert-circle mdi-24px pr-2",
                                }),
                                _c("span", [
                                  _vm._v("Total percentage is not 100%"),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "column is-half is-flex",
                        class: `is-justify-content-${_vm.buttonLocation}`,
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "button is-primary",
                            attrs: { disabled: _vm.disableOk },
                            on: { click: _vm.ok },
                          },
                          [_vm._v("Ok")]
                        ),
                        _c(
                          "button",
                          { staticClass: "button", on: { click: _vm.cancel } },
                          [_vm._v("Cancel")]
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }